import ListTable from "@/components/features/short-longlist/table/list-table";

const OverviewTable = () => {
  return <ListTable listType="longlist" />;
};

export default OverviewTable;